<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    :menu-props="{ maxHeight: '300' }"
    class="filter-menu"
    menu-icon="icon-arrow-down-xs"
    :class="{ 'cui-filter-active': !!modelValue }"
    :placeholder="$t('manageWorkspaces.filters.maxUsersLimit')"
    density="compact"
    variant="outlined"
    rounded
    item-title="title"
    item-value="value"
    :disabled="disabled"
    data-testid="user-protection-limit-select"
    :clearable="clearable"
    clear-icon="icon-rules-close"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #selection="{ item }">
      <span class="body2">{{ item.title }}</span>
    </template>
  </v-select>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { useI18n } from "vue-i18n";
import { UserProtectionLimitFilter } from "@/constants/global-workspaces.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: String as PropType<UserProtectionLimitFilter | null>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const { t } = useI18n();

    const items = computed(() =>
      Object.values(UserProtectionLimitFilter).map((value) => ({
        title: t(`manageWorkspaces.filters.options.${value}`),
        value,
      }))
    );

    return {
      items,
    };
  },
});
</script>
